import { useState, useCallback } from "react";

/**
 * useToast
 * Tiny helper to manage ToastComponent state in a single place.
 * Usage:
 *   const { toastParams, showToast, closeToast } = useToast();
 *   showToast("success" | "danger" | "warning" | "info", "Title", "Body");
 */
export function useToast() {
  const [toastParams, setToastParams] = useState(
    JSON.stringify({ show: false })
  );

  const showToast = useCallback((color, title, body) => {
    setToastParams(JSON.stringify({ show: true, color, title, body }));
  }, []);

  const closeToast = useCallback(() => {
    setToastParams(JSON.stringify({ show: false }));
  }, []);

  return { toastParams, showToast, closeToast };
}
